import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='brokerage-accounts-services'
    moduleName='intro-module'
    // content
    headingText={<>Help grow your money with <WidowBlock>a brokerage account</WidowBlock></>}
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          A brokerage account is an investment account that lets you buy and sell a variety of investments, including stocks, bonds, mutual funds, and Exchange Traded Funds (ETFs). That might sound like a lot of options, but your Northwestern Mutual advisor can help you make sense of it all. They&#39;ll guide you through your choices and recommend the right investment options that will help you reach your unique goals, so you won&#39;t be going it alone.
        </Typography>
        <Link
          id='brokerage-accounts-services-product-intro-cta-fafa'
          variant='buttonLinkPrimary'
          themeType='lightTheme'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Learn about your investment needs from a financial advisor'>
          Get started
        </Link>
      </>
    )}
  />
);
